import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { RefreshCw } from 'lucide-react';

interface UnpublishConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isUnpublishing: boolean;
}

export function UnpublishConfirmationDialog({
  open,
  onClose,
  onConfirm,
  isUnpublishing
}: UnpublishConfirmationDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Unpublish Report?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>This action will:</p>
              <ul className="list-disc pl-5 space-y-1 text-sm">
                <li>Remove the report from public access</li>
                <li>Delete the published file from storage</li>
                <li>Clear publishing metadata from database</li>
                <li>Keep the draft version intact</li>
              </ul>
              <p className="text-sm text-gray-600 mt-3">
                You can republish the report at any time.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isUnpublishing}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={isUnpublishing}
            className="bg-red-600 hover:bg-red-700"
          >
            {isUnpublishing ? (
              <>
                <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
                Unpublishing...
              </>
            ) : (
              'Unpublish Report'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
